export const EstimateStatuses = {
  1: 'New Lead',
  2: 'Estimate Scheduled',
  3: 'Estimate Completed',
  5: 'Lost',
  7: 'Canceled',
};
